import React from 'react';

import { flagStyles } from '../settings';

const SvgCO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1128px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCO;
